import React from 'react';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

const ButtonComponent = ({
  btnName = 'Add New',
  onClick,
  variant = 'contained',
  color = 'primary',
  disableElevation = true,
  sx = { ml: 2 },
  form,
  type = 'submit',
  loading,
  loadingPosition,
  loadingIndicator,
  ...props
}) => {
  if (loading !== undefined) {
    return (
      <LoadingButton
        variant={variant}
        color={color}
        disableElevation={disableElevation}
        onClick={onClick}
        sx={sx}
        form={form}
        type={type}
        loading={loading}
        loadingPosition={loadingPosition}
        loadingIndicator={loadingIndicator}
        {...props}
      >
        {btnName}
      </LoadingButton>
    );
  }

  return (
    <Button
      variant={variant}
      color={color}
      disableElevation={disableElevation}
      onClick={onClick}
      sx={sx}
      form={form}
      type={type}
      {...props}
    >
      {btnName}
    </Button>
  );
};

export default ButtonComponent;